import React from "react";
import { IconButton } from "../../../controls";

// Props HourAndDelete passes to the injected HourSelectionComponent
// (see HourSelection.js — still JS, being converted in parallel).
interface HourSelectionComponentProps {
  hour: string;
  onChange: (hour: string) => void;
  timeIntervals?: number;
  includeTimes?: Date[];
  isClearable?: boolean;
}

interface HourAndDeleteProps {
  onChange: (hour: string) => void;
  HourSelectionComponent: React.ComponentType<HourSelectionComponentProps>;
  time: string;
  key?: React.Key;
  showDelete?: boolean;
  onDelete: () => void;
  timeIntervals?: number;
  includeTimes?: Date[];
  isClearable?: boolean;
}

const HourAndDelete: React.FC<HourAndDeleteProps> = ({
  onChange,
  HourSelectionComponent,
  time,
  key,
  showDelete,
  onDelete,
  timeIntervals,
  includeTimes,
  isClearable,
}) => {
  return (
    <div key={key} className="time-and-delete-container">
      <HourSelectionComponent
        hour={time}
        onChange={onChange}
        timeIntervals={timeIntervals}
        includeTimes={includeTimes}
        isClearable={isClearable}
      />
      {showDelete && (
        <IconButton
          wrapperClassName={"remove-time-btn"}
          type="button"
          data-testid={"remove-date-btn"}
          isIcon={"seem-icon-bin"}
          onClick={(e) => {
            onDelete();
            e.stopPropagation();
          }}
        />
      )}
    </div>
  );
};

export default HourAndDelete;
